export default {
  setCommonPub(state: any, val: string) {
    state.commonPub = val;
    // 只要 val 不是 null/undefined 就更新 localStorage，允许设置为空字符串
    if (val !== null && val !== undefined) {
      localStorage.setItem('commonPub', val);
    }
  }
}
